import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Loading from "../../loadingPage/Loading";
import MultiFileInput from "../MultiFileInput";
import FileInputImg from "../FileInputImg";
import { baseURL, CreateGCC } from "../../../utils/EndPoint";
import axios from "axios";
import { validateForm5Data } from "../../../utils/validation/formValidation";

const Form5 = () => {
  const [loader, setLoader] = useState(false);
  const [agreed, setAgreed] = useState(false);
const [formErrors, setFormErrors] = useState({});
  const kmaPaymentDetails = {
    NonKmaAmount: 11800,
    NonKmaWithGSTAmount: 11800,
    KMAAmount: 8260,
    KMAWithGSTAmount: 8260,
  };

  const initialData = {
    formName: "GCC",
    basicInformation: { organizationName: "", contactDetails: "" },
    sustainabilityVision: { q1: "", q2: "", q3: "", q4: "" },
    environmentalStewardship: { q5: "", q6: "", q7: "", q8: "" },
    humanCapital: { q9: "", q10: "", q11: "", q12: "" },
    ethicalBusiness: { q13: "", q14: "", q15: "" },
    innovationImpact: { q16: "", q17: "", q18: "" },
    performanceMeasurement: { q19: "", q20: "", q21: "" },
    governanceRisk: { q22: "", q23: "", q24: "" },
    assuranceFuture: { q25: "", q26: "", q27: "" },
    attachments: { supportedDocuments: [] },
    paymentDetails: {
      mode: "",
      amountWithGst: kmaPaymentDetails.NonKmaWithGSTAmount,
      isKmaMember: "",
      receipt: null,
      membershipId: "",
    },
  };

  const [formData, setFormData] = useState(initialData);

  /* ================= HANDLERS ================= */
const sectionHandler = (section) => (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], [name]: value },
    }));

    // <-- ADD THIS: Clear error instantly
    if (value.trim() !== "") {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

const inPutChangeHandler = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updated = { ...prev };

      // KMA Member Logic
      if (name === "isKmaMember") {
        // If they select the placeholder (""), keep it blank and amount at 11800
        if (value === "") {
          updated.paymentDetails = {
            ...updated.paymentDetails,
            isKmaMember: "",
            amountWithGst: 11800,
          };
        } else {
          // Otherwise, set true/false and adjust amount
          const isKma = value === "true";
          updated.paymentDetails = {
            ...updated.paymentDetails,
            isKmaMember: isKma,
            amountWithGst: isKma ? 8260 : 11800,
          };
        }
      } 
      // Mode & Membership ID Logic
      else if (name === "mode" || name === "membershipId") {
        updated.paymentDetails = {
          ...updated.paymentDetails,
          [name]: value,
        };
      }

      return updated;
    });

    // Clear error instantly
    if (value.trim() !== "") {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };



const submitHandler = async (e) => {
  e.preventDefault();

  // 1. Run Validation
  const errors = validateForm5Data(formData);
  setFormErrors(errors);

  // 2. Show ALL errors in toasts if they exist
  if (Object.keys(errors).length > 0) {
    Object.values(errors).forEach((errorMsg) => toast.error(errorMsg));
    return;
  }

  try {
    setLoader(true);
    toast.dismiss(); // 3. Clear pre-existing toasts before API call

    const response = await axios.post(`${baseURL}${CreateGCC}`, formData);

    // 4. Wrap success in status 200 check
if (response.status === 200 || response.status === 201) { 
       toast.dismiss(); // 5. Instantly wipe toasts on success

      if (response?.data?.redirectUrl) {
        window.location.href = response.data.redirectUrl;
        toast.warning("Please wait for the Payment Gateway. DO NOT CLOSE THE WINDOW.");
        return;
      }

      toast.success("Application submitted successfully");
      setFormData(initialData);
      setAgreed(false);
      window.scrollTo(0, 0);
    }
  } catch (error) {
    console.log("API ERROR:", error);
    toast.error(error?.response?.data?.msg || "Something went wrong. Try again.");
  } finally {
    setLoader(false);
  }
};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <h1 className="font-bold text-textColor text-2xl text-center mb-5 lg:mb-10">
        Sustainable GCC Award 2026
      </h1>

      <div className="flex items-start justify-center border rounded-xl shadow-xl w-full max-w-[1280px] mx-auto">
        <form onSubmit={submitHandler} className="w-full md:px-20 p-5 md:p-10">
          {/* 1. BASIC INFORMATION */}
          <div className="text-start w-full font-semibold mb-2">
            <h2 className="text-black text-lg font-bold">Basic Information</h2>
          </div>
          <div className="w-full md:mt-3 flex flex-col gap-4 py-1">
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Full Legal Name of the Organization
              </label>
<input
  type="text"
  name="organizationName"
  value={formData.basicInformation.organizationName}
  onChange={sectionHandler("basicInformation")}
  className={`border w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none ${
    formErrors.organizationName ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>
{formErrors.organizationName && <p className="text-red-500 text-sm mt-1">{formErrors.organizationName}</p>}
            </div>
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Name, designation, and contact details of responsible person
              </label>
              <textarea
                name="contactDetails"
                value={formData.basicInformation.contactDetails}
                onChange={sectionHandler("basicInformation")}
                rows={3}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none"
              />
            </div>
          </div>

          {/* 2. QUESTIONNAIRE SECTIONS */}
          {[
            {
              title: "Sustainability Vision, Strategy & Leadership",
              key: "sustainabilityVision",
              qs: [
                {
                  l: "1. Describe the role of the GCC within the global organisation and how sustainability is integrated.",
                  n: "q1",
                },
                {
                  l: "2. Explain how sustainability priorities are identified and aligned with global goals.",
                  n: "q2",
                },
                {
                  l: "3. Specify leadership roles responsible for sustainability governance.",
                  n: "q3",
                },
                {
                  l: "4. How does leadership ensure accountability and risk management?",
                  n: "q4",
                },
              ],
            },
            {
              title: "Environmental Stewardship & Climate Action",
              key: "environmentalStewardship",
              qs: [
                {
                  l: "5. Annual energy consumption per employee and efficiency measures.",
                  n: "q5",
                },
                {
                  l: "6. Initiatives to reduce Scope 2 and Scope 3 emissions.",
                  n: "q6",
                },
                {
                  l: "7. Actions to promote green buildings or renewable energy.",
                  n: "q7",
                },
                {
                  l: "8. Management of waste, e-waste, and resource efficiency.",
                  n: "q8",
                },
              ],
            },
            {
              title: "Human Capital, Skills & Social Responsibility",
              key: "humanCapital",
              qs: [
                {
                  l: "9. Approach to employee well-being and safety.",
                  n: "q9",
                },
                {
                  l: "10. Current diversity metrics and leadership targets.",
                  n: "q10",
                },
                {
                  l: "11. Contribution to inclusive growth and local talent ecosystems.",
                  n: "q11",
                },
                {
                  l: "12. Initiatives to build ESG competencies among employees.",
                  n: "q12",
                },
              ],
            },
            {
              title: "Ethical Business, Data Integrity & Trust",
              key: "ethicalBusiness",
              qs: [
                {
                  l: "13. Policies for ethical conduct, data privacy, and cybersecurity.",
                  n: "q13",
                },
                {
                  l: "14. Ensuring transparency and integrity in sustainability reporting.",
                  n: "q14",
                },
                {
                  l: "15. Description of any ethical or compliance issues during the period.",
                  n: "q15",
                },
              ],
            },
            {
              title: "Innovation, Technology & Global Impact",
              key: "innovationImpact",
              qs: [
                {
                  l: "16. Leveraging technology for sustainability outcomes.",
                  n: "q16",
                },
                {
                  l: "17. Examples of enabling sustainability across global business units.",
                  n: "q17",
                },
                {
                  l: "18. Collaboration with startups or academia for innovation.",
                  n: "q18",
                },
              ],
            },
            {
              title: "Performance Measurement & Improvement",
              key: "performanceMeasurement",
              qs: [
                {
                  l: "19. Defined sustainability KPIs and monitoring processes.",
                  n: "q19",
                },
                {
                  l: "20. Measurable improvements achieved against KPIs over the last year.",
                  n: "q20",
                },
                {
                  l: "21. Key sustainability achievements (Max 300 words).",
                  n: "q21",
                },
              ],
            },
            {
              title: "Governance, Risk & Compliance",
              key: "governanceRisk",
              qs: [
                {
                  l: "22. Governance structure for sustainability and global integration.",
                  n: "q22",
                },
                {
                  l: "23. Identification and mitigation of sustainability-related risks.",
                  n: "q23",
                },
                {
                  l: "24. Alignment with frameworks like SDGs, GRI, or BRSR.",
                  n: "q24",
                },
              ],
            },
            {
              title: "Assurance, Learning & Future Readiness",
              key: "assuranceFuture",
              qs: [
                {
                  l: "25. Internal or external assurance of performance data.",
                  n: "q25",
                },
                {
                  l: "26. Integration of learnings into future GCC strategy.",
                  n: "q26",
                },
                {
                  l: "27. Priorities and planned initiatives for the next 2-3 years.",
                  n: "q27",
                },
              ],
            },
          ].map((sec) => (
            <div key={sec.key}>
              <div className="text-start w-full font-semibold my-5">
                <h2 className="text-black text-lg font-bold">{sec.title}</h2>
              </div>
              <div className="space-y-4">
                {sec.qs.map((q) => (
                  <div key={q.n} className="w-full space-y-2">
                    <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                      {q.l}
                    </label>
<textarea
  name={q.n}
  value={formData[sec.key][q.n]}
  onChange={sectionHandler(sec.key)}
  rows={4}
  className={`border w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>
{/* Add the error message below the textarea */}
{formErrors[q.n] && <p className="text-red-500 text-sm mt-1">{formErrors[q.n]}</p>}
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* 3. FINANCE SECTION */}
          {/* 3. FINANCE SECTION */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">
              Financial and Payment Details
            </h2>
          </div>

          <div className="w-full flex flex-col md:flex-row gap-4 py-1">
            {/* Membership Dropdown */}
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                is KMA Member?*
              </label>
<select
    name="isKmaMember"
    value={String(formData.paymentDetails.isKmaMember)} // Cast to string to match options
    onChange={inPutChangeHandler}
    className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none font-medium"
  >
    <option value="">Select Membership Status</option> 
    <option value="false">Non-KMA Member</option>
    <option value="true">KMA Member</option>
  </select>
            </div>

            {/* Conditional Membership ID Column */}
<div
    className={`w-full space-y-2 ${
      formData.paymentDetails.isKmaMember === true || formData.paymentDetails.isKmaMember === "true" 
        ? "block" 
        : "hidden"
    }`}
  >
              {" "}
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Membership Id*
              </label>
              <input
                type="text"
                name="membershipId"
                value={formData.paymentDetails.membershipId}
                onChange={inPutChangeHandler}
                placeholder="Enter your ID"
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none"
              />
            </div>

            {/* Application Amount Display */}
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Application Amount (with GST) :
              </label>
              <input
                type="text"
                readOnly
                value={formData.paymentDetails.amountWithGst}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded bg-gray-50 outline-none"
              />
            </div>
          </div>

          <div className="w-full flex flex-col md:flex-row gap-4 py-1 mt-2">
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Payment Details :*
              </label>

              <select
                name="mode"
                value={formData.paymentDetails.mode}
                onChange={inPutChangeHandler}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none font-medium"
              >
                <option value="">Select Mode</option>
                <option value="Cheque">Cheque</option>
                <option value="DD">DD</option>
                <option value="Online">Online</option>
              </select>
            </div>

            {formData.paymentDetails.mode !== "Online" &&
              formData.paymentDetails.mode !== "" && (
                <FileInputImg
                  className="w-full space-y-2"
                  label="Payment Receipt (png or jpg)"
setFile={(file) => {
    if (!file) return;
    setFormData((prev) => ({
      ...prev,
      paymentDetails: { ...prev.paymentDetails, receipt: file },
    }));
    // <-- ADD THIS: Clear error instantly
    setFormErrors((prev) => ({ ...prev, receipt: "" }));
  }}
                />
              )}
          </div>

          {/* 4. SUPPORTED DOCUMENTS */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">
              Required Attachments
            </h2>
          </div>
<MultiFileInput
  name="supportedDocuments"
  label="Upload Supporting Documents (Multiple)"
setFiles={(newFiles) => {
    setFormData((prev) => {
      const existingFiles = Array.isArray(prev.attachments?.supportedDocuments)
        ? prev.attachments.supportedDocuments
        : [];
      const updatedFiles = [...existingFiles, ...newFiles];

      // <-- ADD THIS: Clear error instantly
      if (updatedFiles.length > 0) {
        setFormErrors((prevErr) => ({ ...prevErr, supportedDocuments: "" }));
      }

      return {
        ...prev,
        attachments: { ...prev.attachments, supportedDocuments: updatedFiles },
      };
    });
  }}
/>
{Array.isArray(formData?.attachments?.supportedDocuments) &&
  formData.attachments.supportedDocuments.length > 0 && (
    <div className="mt-4 space-y-2">
      {formData.attachments.supportedDocuments.map((file, index) => (
        <div
          key={file.key || index}
          className="flex items-center justify-between bg-gray-100 px-4 py-2 rounded text-sm"
        >
          <span className="truncate">{file.name}</span>

          <button
            type="button"
            onClick={() => {
              setFormData((prev) => ({
                ...prev,
                attachments: {
                  ...prev.attachments,
                  supportedDocuments:
                    prev.attachments.supportedDocuments.filter(
                      (_, i) => i !== index
                    ),
                },
              }));
            }}
            className="text-red-500 font-medium hover:underline"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
)}

          {/* SUBMIT AREA */}
          <div className="w-full flex flex-col md:flex-row gap-2 py-1 mt-8">
            <span className="text-xs md:text-sm">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                className="me-2"
              />
              I agree to abide by the rules of the KMA Awards 2026 and confirm
              all information is correct.
            </span>
          </div>

          <div className="w-full flex justify-center mt-10">
            <button
type="submit"
disabled={!agreed}
              className="flex items-center justify-center border p-2 px-10 rounded bg-red-500 text-white font-medium"
            >
              {formData.paymentDetails.mode === "Online"
                ? "Pay Now & Submit"
                : "Submit"}
            </button>
          </div>
        </form>
        {loader && <Loading />}
      </div>
    </>
  );
};

export default Form5;
